// SvgImg
//
// Loads an svg as an img element.
//
// An overlay can be added in top of the svg to affect its color,
// such as:
//
// ImageOverlay={<div className="medButColOverlay" />}
//
// '& .medButColOverlay': {
//   position: 'absolute',
//   top: 0,
//   left: 0,
//   background: 'linear-gradient(60deg, #244767, #1B8EB1)',
//   // background: 'linear-gradient(30deg, #108000, #244767)',
//   height: '100%',
//   width: '100%',
//   mixBlendMode: 'screen',
// },
//

import classNames from 'classnames';
import PropTypes from 'prop-types';
import {
  useMemo,
  useState,
} from 'react';

import { emptyObject } from '../utils';

const SvgImg = function SvgImg(props) {
  const {
    description = '',
    src = '/images/svg/gui/coneQuestion.svg',
    ImageOverlay = null,
    style = emptyObject,
    className,
    defaultDotDotDot,
    defaultCone,
  } = props;

  const [imageSrc, setImageSrc] = useState(src);

  const defaultSrc = useMemo(
    () => {
      if (defaultDotDotDot) return '/images/svg/gui/dotdotdot.svg';
      if (defaultCone) return '/images/svg/gui/cone.svg';

      return '/images/svg/gui/squareCrossed.svg';
    },
    [defaultCone, defaultDotDotDot],
  );

  const handleError = () => {
    // console.group(`SvgImg cannot find src=${src}`);
    setImageSrc(defaultSrc);
  };

  // console.log(`SvgImg src=${src}`);

  const divClassName = useMemo(
    () => classNames(
      'relative overflow-hidden',
      className,
    ),
    [className],
  );

  return (
    <div
      style={style}
      className={divClassName}
    >
      {ImageOverlay}
      <img
        src={imageSrc}
        alt={description}
        className="w-full h-full"
        onError={handleError}
      />
    </div>
  );
};

SvgImg.propTypes = {
  style: PropTypes.shape({ }),
  className: PropTypes.string,
  description: PropTypes.string,
  src: PropTypes.string,
  ImageOverlay: PropTypes.node,
  defaultDotDotDot: PropTypes.bool,
  defaultCone: PropTypes.bool,
};

export default SvgImg;
